// Keyboard control for the watch-and-capture loop.
//
// Explicit keys rather than relying on focus alone: pausing when you focus the capture box
// is right, but resuming when you leave it isn't always - adding three words before
// carrying on is a normal thing to want, and focus-based resume can't tell that apart from
// "I'm done". So focus pauses, and a key resumes.
//
// These only work while our document has focus. Click into the player and keystrokes go to
// YouTube's iframe instead, which is cross-origin and not ours to intercept. That's why the
// page carries its own play/pause and next/previous buttons: with those, there's no reason
// to click the video, and focus stays where the shortcuts work.
//
// Keys are chosen not to collide with YouTube's own, since both sets are live depending on
// where focus sits. Space and k mean play/pause in both, which is a collision without a
// conflict. "c" is deliberately NOT used here - it toggles captions in the player, and a
// key that means two different things two inches apart is worse than no key at all.

export const KEYS = [
  { hint: "space / k", label: "Play or pause" },
  { hint: "j", label: "Back 10 seconds" },
  { hint: "q", label: "Jump to Quick Capture" },
  { hint: "esc", label: "Leave Quick Capture and resume" },
  { hint: "n / →", label: "Next clip" },
  { hint: "p / ←", label: "Previous clip" },
];

export const CAPTURE_KEYS = ["q"];
export const TOGGLE_KEYS = [" ", "k"];
export const REWIND_KEYS = ["j"];
export const NEXT_KEYS = ["n", "ArrowRight"];
export const PREVIOUS_KEYS = ["p", "ArrowLeft"];

export const REWIND_SECONDS = 10;

// A single-letter shortcut must never fire while someone is writing a word into the
// capture box - "q" and "n" are letters before they're commands.
export function isTyping(target) {
  if (!target) return false;
  if (target.isContentEditable) return true;

  return ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName);
}

export function matches(event, names) {
  return names.includes(event.key);
}
